import { useEffect, useState } from 'react';
import type { PromptSuggestionItem } from './MessageList.helpers';

interface MessageListSuggestionChipsProps {
  suggestions: PromptSuggestionItem[];
  onSelect: (suggestion: PromptSuggestionItem) => void;
  disabled?: boolean;
}

export function MessageListSuggestionChips({
  suggestions,
  onSelect,
  disabled,
}: MessageListSuggestionChipsProps) {
  const maxVisibleChips = 4;
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [suggestions]);

  const hasOverflow = suggestions.length > maxVisibleChips;
  const visibleSuggestions =
    hasOverflow && !expanded ? suggestions.slice(0, maxVisibleChips) : suggestions;
  const hiddenCount = hasOverflow ? suggestions.length - maxVisibleChips : 0;

  return (
    <div className="prompt-suggestions">
      {visibleSuggestions.map((suggestion, index) => (
        <button
          key={`${suggestion.toolName}-${index}`}
          className="suggestion-chip"
          type="button"
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
        >
          {suggestion.text}
        </button>
      ))}
      {hasOverflow && (
        <button
          type="button"
          className="suggestion-chip suggestion-chip-toggle"
          disabled={disabled}
          onClick={() => setExpanded((current) => !current)}
        >
          {expanded ? 'Show less' : `+${hiddenCount} more`}
        </button>
      )}
    </div>
  );
}
